<span
  class="value-label text-primary d-inline-block text-nowrap"
  [class.text-secondary]="disabled"
  [style.margin-left.%]="percent"
  [style.transform]="'translate(-' + percent + '%)'"
>
  {{ value }}
</span>
